<template>
  <div class="train-evaluate">
    <div class="evaluate-bg">
      <div class="eva-title">
        <img src="@/assets/images/train/evaluate_pic_Line@2x.png" class="bg" alt="" />
        活动评价
      </div>
      <div class="title">
        1.您是通过什么途径了解本次学术活动？<span class="txt">【多选】</span>
      </div>
      <van-checkbox-group :disabled="showEvaBtn === 'Y' ? true : false" icon-size="16px" checked-color="#EB1700"
        v-model="knowChannel">
        <van-checkbox name="1" shape="square">强生员工</van-checkbox>
        <van-checkbox name="2" shape="square">同事/专家推荐</van-checkbox>
        <van-checkbox name="3" shape="square">心相伴</van-checkbox>
        <van-checkbox name="4" shape="square">朋友圈/微信群</van-checkbox>
        <van-checkbox name="5" shape="square">iEP</van-checkbox>
        <van-checkbox name="6" shape="square">其他</van-checkbox>
      </van-checkbox-group>
      <div class="title">2.您会将此活动推荐给其他人吗？</div>
      <!-- <div class="start-block">
        <van-rate v-model="score" :readonly="showEvaBtn === 'Y' ? true : false" allow-half void-icon="star" size="20" color="#EB1700" void-color="#eee" />
        <div class="score" v-text="
          (score * 20) + '分'
        "></div>
      </div> -->
      <div class="start-block">
        <div class="block-txt" :class="score === index ? 'cur' : ''" v-for="(item, index) in 11" :key="index"
          @click="handleClickScore(index)">{{ item - 1 }}</div>
      </div>
      <div class="start-txt">
        <div class="start-txt1">不推荐</div>
        <div class="start-txt1">极其推荐</div>
      </div>
      <div class="title">3.您对下次活动内容的期待与建议？</div>
      <van-cell-group inset>
        <van-field v-model="proposal" rows="2" maxlength="200" autosize show-word-limit type="textarea"
          :disabled="showEvaBtn === 'Y' ? true : false" placeholder="请输入您的期待与建议？" />
      </van-cell-group>
    </div>
    <div class="submit-btn" v-if="showEvaBtn === 'N'" @click="submit">
      提 交
    </div>
  </div>
</template>

<script>
import { trainEvaluate, trainGetEvaluate } from '@/api/train.js'
import { Toast } from 'vant'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'Evaluate',
  data () {
    return {
      showEvaBtn: 'N',
      score: -1,
      proposal: '',
      knowChannel: []
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    this.handleGetEva()
  },
  methods: {
    handleClickScore (index) {
      this.score = index
    },
    submit () {
      if (this.knowChannel.length <= 0) {
        Toast('您是通过什么途径了解本次学术活动？')
        return
      }
      if (this.score < 0) {
        Toast('您会将此活动推荐给其他人吗？')
        return
      }
      const params = {
        academicActivityId: this.$route.query.trainId,
        studentMultiCode: this.userInfo.multiCode,
        iepUserId: this.userInfo.id,
        sourceChannel: this.knowChannel.toString(),
        academicActivityScore: this.score,
        proposalText: this.proposal
      }
      trainEvaluate(params).then(() => {
        Toast('评价成功')
        this.handleGetEva()
      })
    },
    handleGetEva () {
      trainGetEvaluate({
        academicActivityId: this.$route.query.trainId,
        studentMultiCode: this.userInfo.multiCode,
        iepUserId: this.userInfo.id,
        pageNum: 1,
        pageSize: 1
      }).then(res => {
        const returnData = res.data ? res.data.list : []
        if (returnData.length <= 0) return
        this.knowChannel = returnData[0].sourceChannel.split(',')
        this.score = returnData[0].academicActivityScore
        this.proposal = returnData[0].proposalText
        this.showEvaBtn = 'Y'
      })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.train-evaluate {
  box-sizing: border-box;
  padding: 12px;
  padding-bottom: 73px;
  background-color: #f0f1f6;
  min-height: 100vh;

  .evaluate-bg {
    background-color: #fff;
    border-radius: 4px;
    padding: 0 18px;
    padding-bottom: 10px;
    box-sizing: border-box;

    .eva-title {
      text-align: center;
      padding-top: 24px;
      position: relative;
      box-sizing: border-box;

      .bg {
        width: 100%;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(10px);
      }
    }

    .title {
      font-size: 14px;
      color: #2b2b2b;
      margin-bottom: 16px;
      margin-top: 24px;

      .txt {
        font-size: 10px;
        color: #EB1700;
        font-weight: bold;
      }
    }

    /deep/ .van-checkbox {
      align-items: center;
      height: 20px;
      padding: 0;
      box-sizing: border-box;
      margin-bottom: 14px;

      .van-checkbox__icon--checked {
        .van-icon {
          background-color: #EB1700;
          border-color: #EB1700;
          color: #fff;
        }
      }

      .van-icon,
      .van-checkbox__icon {
        width: 14px;
        height: 14px;
        margin-right: 10px;
        font-size: 10px;
      }

      .van-checkbox__label {
        font-size: 14px;
        color: #2b2b2b;
      }
    }

    // .start-block {
    //   display: flex;
    //   align-items: center;
    //   height: 20px;
    //   margin-bottom: 16px;

    //   .label {
    //     font-size: 14px;
    //     color: #2b2b2b;
    //     margin-right: 24px;
    //   }

    //   .val {
    //     display: flex;
    //     align-items: center;
    //     height: 20px;

    //     .start-img {
    //       width: 18px;
    //       height: 18px;
    //       margin-right: 10px;
    //     }
    //   }

    //   .score {
    //     font-size: 14px;
    //     color: #2b2b2b;
    //     margin-left: 20px;
    //   }
    // }

    .start-block {
      display: flex;
      justify-content: space-between;

      .block-txt {
        width: 24px;
        height: 28px;
        text-align: center;
        line-height: 28px;
        border-radius: 2px;
        border: 1px solid #D8D8D8;
        font-size: 13px;
        color: #2B2B2B;
        box-sizing: border-box;

        &.cur {
          border-color: #EB1700;
          background-color: rgba(254, 91, 0, 0.10);
          color: #EB1700;
        }
      }

      .score {
        color: #999;
        font-size: 14px;
        margin-left: 50px;
      }
    }

    .start-txt {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 11px;
      color: #B9B7B7;
      margin-top: 5px;
    }

    .van-cell-group--inset {
      margin: 0;
      border: 1px solid #eeeeee;
      border-radius: 4px;
    }
  }

  .submit-btn {
    position: fixed;
    bottom: 17px;
    left: 16px;
    border-radius: 30px;
    background-color: #EB1700;
    width: 343px;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #ffffff;
    justify-content: center;
  }
}

.van-popup {
  .van-popover__content {
    display: flex;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;

    .start-img-pop {
      width: 18px;
      height: 18px;
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/academicActivities/evaluate.vue